import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import myAxios from '../../../../lib/axios';

const initialState = {
    data: [],
};

export const fetchBlogType = createAsyncThunk(
    'masters/blogType',
    async (query) => {
        try {
            const response = await myAxios.get(`/masters/blogCategories`);
            return { success: true, message: "BlogTypes fetched successfully!", data: response?.data?.blogCategories };
        } catch (error) {
            if (error?.response?.data) {
                return { success: false, message: error?.response?.data?.message };
            } else {
                return { success: false, message: 'Sorry, something went wrong!' };
            }
        }
    },
);

export const createBlogType = createAsyncThunk(
    'masters/blogType',
    async (formData) => {
        try {
            const response = await myAxios.post(`/masters/blogCategories`, formData);

            return { success: true, message: "Blog Types added successfully!", data: response?.data };
        } catch (error) {
            if (error?.response?.data) {
                return { success: false, message: error?.response?.data?.message };
            } else {
                return { success: false, message: 'Sorry, something went wrong!' };
            }
        }
    },
);

export const updateBlogType = createAsyncThunk(
    'masters/updateBlogType',
    async (formData) => {
        try {
            const response = await myAxios.put(`/masters/blogCategories/${formData.blogTypeId}`, formData);

            return { success: true, message: "Blog Types updated successfully!", data: response?.data };
        } catch (error) {
            if (error?.response?.data) {
                return { success: false, message: error?.response?.data?.message };
            } else {
                return { success: false, message: 'Sorry, something went wrong!' };
            }
        }
    },
);

export const deleteBlogType = createAsyncThunk(
    'masters/deleteBlogType',
    async (query) => {
        try {
            const response = await myAxios.delete(`/masters/blogCategories/${query?.blogTypeId}`);

            return { success: true, message: "Blog Types deleted successfully!", data: response?.data };
        } catch (error) {
            if (error?.response?.data) {
                return { success: false, message: error?.response?.data?.message };
            } else {
                return { success: false, message: 'Sorry, something went wrong!' };
            }
        }
    },
);


const blogTypeSlice = createSlice({
    name: 'blogType',
    initialState,
    reducers: {
        clearBlogTypeData: state => {
            state.data = [];
        },
        setBlogTypeData: (state, action) => {
            state.data = action.payload;
        },

    },
});

export const blogTypeReducer = blogTypeSlice.reducer;
export const { clearBlogTypeData, setBlogTypeData } = blogTypeSlice.actions;

export const selectBlogTypeData = (state) => state.blogType.data;
